/**
 * @generated SignedSource<<fde5be42373304d8e04673387c3e1dff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EmployeeProvider = "IPOOL" | "QUINYX" | "SOFTONE" | "TILTID";
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeScheduleIcon_widgetEmployeeSchedule$data = {
  readonly provider: EmployeeProvider | null;
  readonly " $fragmentType": "WidgetEmployeeScheduleIcon_widgetEmployeeSchedule";
};
export type WidgetEmployeeScheduleIcon_widgetEmployeeSchedule$key = {
  readonly " $data"?: WidgetEmployeeScheduleIcon_widgetEmployeeSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleIcon_widgetEmployeeSchedule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeScheduleIcon_widgetEmployeeSchedule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    }
  ],
  "type": "WidgetEmployeeSchedule",
  "abstractKey": null
};

(node as any).hash = "79f116d3524a3506453d0224da548379";

export default node;
